var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lib-manage-wrapper"},[(_vm.currentModule === 'lib')?_c('lib-list',{on:{"showWordList":_vm.showWordList}}):_vm._e(),(_vm.currentModule === 'word')?_c('word-list',{attrs:{"lib":_vm.lib},on:{"goBack":function($event){_vm.currentModule = 'lib'}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }